import { LBButton, LBJiraIcon } from '@linearb/buzz';
import { connectJiraOAuth2 } from 'common/services/jira-auth.service';

const CloudForm = () => {
  return (
    <div className='mt-7'>
      <div className='mb-4 text-sm font-medium'>
        You’ll be redirected to Jira to log in and authorize access. <br />
        Once you’re done, you’ll return here automatically.
      </div>
      <LBButton onClick={() => connectJiraOAuth2()} variant='default'>
        Connect to Jira
        <LBJiraIcon className='size-4' />
      </LBButton>
    </div>
  );
};

export default CloudForm;
